import styled from "styled-components"

import { useCustomerDashboard } from "../CustomerDashboardContext"
import { Widget, WidgetsContainer } from "./styled"
import { DeviceDetailsWidget } from "./widgets/DeviceDetailsWidget"
import { PerformanceTestSnapshotWidget } from "./widgets/PerformanceTestSnapshotWidget"
import { RecentAlertsWidget } from "./widgets/RecentAlertsWidget"
import { SystemStatusSummaryWidget } from "./widgets/SystemStatusSummaryWidget"
import { TemperatureVsSetpointWidget } from "./widgets/TemperatureVsSetpointWidget"

const DummyWidget = styled(Widget)`
  height: 1px !important;
  min-height: 1px !important;
  background-color: transparent !important;
  border: none !important;
  padding: 0 !important;
  margin: 0 !important;
`

export const CustomerDashboardOverview = () => {
  const { isSidebarOpen } = useCustomerDashboard()

  return (
    <WidgetsContainer sidebarOpen={isSidebarOpen}>
      <DeviceDetailsWidget />
      <TemperatureVsSetpointWidget />
      <SystemStatusSummaryWidget />
      <RecentAlertsWidget />
      <PerformanceTestSnapshotWidget />
      <DummyWidget />
    </WidgetsContainer>
  )
}
